import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { MTableToolbar } from '@material-table/core';
import { MTable } from '../../../../../Components';
import { useFilter } from '../../../../../Components/ListFilter/useFilter';
import { useAptorApi } from '../../../../../Api';
import moment from 'moment';
import { SaveAlt } from '@material-ui/icons';
import { ObservationFilter } from './Filters';
import { ObservationView } from './ObservationView';
import { useStyles } from '../../../LawPortal.styles';

export const Observation = () => {
  const { formatMessage } = useIntl();
  const { api } = useAptorApi();
  const tableRef = React.useRef<any>(null);
  const [filters, setFilter] = useFilter();
  const [observationPlan, setObervationPlan] = useState<any>([]);
  const [filtersInitialized, setFiltersInitialized] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const classes = useStyles();

  const getObservationPlan = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await api.getObservationPlan({
        filters: { ...filters, status: filters.status?.length ? filters.status[0] : null },
      });
      setObervationPlan(response.plans || []);
    } catch (error) {
      console.error('Error fetching report plans:', error);
      setObervationPlan([]);
    } finally {
      setIsLoading(false);
    }
  }, [api, filters]);

  useEffect(() => {
    if (Object.keys(filters || {}).length > 0 && !filtersInitialized) {
      setFiltersInitialized(true);
    }
  }, [filters, filtersInitialized]);

  useEffect(() => {
    if (filtersInitialized) {
      getObservationPlan();
    }
  }, [filters, filtersInitialized, getObservationPlan]);

  const ObservationColumns = useMemo(
    () => [
      {
        title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.name-of-control' }),
        field: 'name',
      },
      {
        title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.Company-unit' }),
        field: 'companyUnit',
      },
      {
        title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.Start-date' }),
        field: 'startDate',
        render: (row: any) => moment(row?.startDate).format('YYYY-MM-DD'),
        sorting: false,
      },
      {
        title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.End-date' }),
        field: 'endDate',
        render: (row: any) => moment(row?.endDate).format('YYYY-MM-DD'),
        sorting: false,
      },
    ],
    [formatMessage],
  );

  const handleExport = async () => {
    const response = await api.ExportNonConformities({ status: "" });
    const blob = await response?.blob();
    const contentDisposition = response.headers.get('Content-Disposition');
    let fileName = 'LawsExport.xlsx';
    if (contentDisposition && contentDisposition.includes('attachment')) {
      const matches = /filename=([^;]*)/.exec(contentDisposition);
      if (matches && matches[1]) {
        fileName = matches[1];
      }
    }
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  };

  return (
    <>
      <ObservationFilter filters={filters} setFilter={setFilter} />
      <hr style={{ marginTop: '25px', marginBottom: '25px' }} />
      <MTable
        tableRef={tableRef}
        columns={ObservationColumns}
        data={observationPlan}
        isLoading={isLoading}
        options={{
          detailPanelColumnAlignment: 'right',
          pageSizeOptions: [10, 25, 50, 100],
        }}
        detailPanel={[
          {
            tooltip: formatMessage({ id: 'text.expend' }),
            render: (rowData: any) => (
              <ObservationView PlanData={rowData?.rowData} filters={filters} onObservationUpdated={getObservationPlan} />
            ),
          },
        ]}
        components={{
          Toolbar: (props) => (
            <div className={classes.toolbar}>
              <MTableToolbar {...props} />
              <SaveAlt style={{ cursor: 'pointer' }} onClick={() => handleExport()} />
            </div>
          ),
        }}
      />
    </>
  );
};